<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		selection
		:excel="isButton_(scrId, 'EX')"
		paging
		@changedPage="onChangePage"
		:currentPage="widgets.currentPage"
		:pageUnit="widgets.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="widgets.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line icon="square-plus" v-if="isButton_(scrId, 'AD')" :onClick="addAction">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line icon="file" v-if="isButton_(scrId, 'AD')" :onClick="saveAction">{{ getMessage_('SWCC000138') }}</sf-button>
			<sf-button line icon="trash" v-if="isButton_(scrId, 'CD')" :onClick="deleteAction" color="error">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>
<script>
import * as yup from 'yup';
import { serviceComputed, serviceMethods } from '@common/WidgetMaster/store/helpers';
import { rootComputed } from '@/store/common/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	data() {
		return {
			screen: {},
			rows: [],
			addIndex: 0,
			addRowData: {
				state: 'I',
				widgetMstFileId: '',
				widgetTitle: '',
				minH: 1,
				minW: 1,
				resizeYn: 'Y',
				parameter: '',
				useYn: 'Y'
			}
		};
	},

	computed: {
		...rootComputed,
		...serviceComputed,

		schema() {
			return yup.array().of(
				yup.object().shape({
					widgetTitle: yup
						.string()
						.trim()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000224')]))
						.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000224'), 1]))
						.max(100, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000224'), 20])),
					widgetMstFileId: yup
						.string()
						.trim()
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000733')]))
						.max(200, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000733'), 20])),
					parameter: yup
						.string()
						.nullable()
						.trim()
						.max(500, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000228'), 20])),
					minW: yup.number().nullable().min(1, this.getMessage_('SWCC000951')),
					minH: yup.number().nullable().min(1, this.getMessage_('SWCC000951'))
				})
			);
		},
		columns() {
			return [
				{ label: this.getMessage_('SWCC000230'), prop: 'widgetKey', minWidth: '150px' },
				{
					label: this.getMessage_('SWCC000733'),
					prop: 'widgetMstFileId',
					minWidth: '200px',
					form: {
						type: 'input',
						maxLength: 200
					}
				},
				{
					label: this.getMessage_('SWCC000224'),
					prop: 'widgetTitle',
					minWidth: '200px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000225'),
					prop: 'minW',
					minWidth: '160px',
					form: {
						type: 'number',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000226'),
					prop: 'minH',
					minWidth: '160px',
					form: {
						type: 'number',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000227'),
					prop: 'resizeYn',
					minWidth: '150px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('SWCC000228'),
					prop: 'parameter',
					minWidth: '500px',
					form: {
						type: 'input',
						maxLength: 500
					}
				},
				{
					label: this.getMessage_('SWCC000145'),
					prop: 'useYn',
					minWidth: '100px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{ label: this.getMessage_('SWCC000229'), prop: 'cnt', minWidth: '100px' },
				{ label: this.getMessage_('SWCC000005'), prop: 'regId', minWidth: '150px' },
				{ label: this.getMessage_('SWCC000146'), prop: 'dRegDt', minWidth: '180px' },
				{ label: this.getMessage_('SWCC000172'), prop: 'chgId', minWidth: '150px' },
				{ label: this.getMessage_('SWCC000171'), prop: 'dChgDt', minWidth: '180px' }
			];
		}
	},

	watch: {
		'widgets.data': function (value) {
			this.rows = value;
		}
	},

	methods: {
		...serviceMethods,

		//선택된 Rows 정보
		getSelectedRows() {
			return this.$refs.table.getSelectedRows();
		},

		//페이징 정보 변경 이벤트
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.search({ currentPage: currentPageVal, pageUnit: pageUnitVal });
		},

		//위젯 조회
		search({ currentPage, pageUnit }) {
			this.$sf_toggleLoading(true);
			this.select_({
				...this.searchParams,
				currentPage,
				pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//테이블 행 추가 버튼 클릭
		addAction() {
			const data = { ...this.addRowData, addIndex: this.addIndex++ };
			this.rows.unshift(data);
			this.$refs.table.getTable().toggleRowSelection(data);
		},

		//저장 버튼 클릭
		saveAction() {
			const selected = this.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},

		//삭제 버튼 클릭
		deleteAction() {
			const selected = this.getSelectedRows();
			const addRows = selected.filter(row => row.state === 'I');
			const deleteRows = selected.filter(row => row.state !== 'I');

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});

				return;
			} else if (addRows.length === selected.length) {
				this.rows = this.rows.filter(row => {
					if (addRows.findIndex(aRow => aRow.addIndex === row.addIndex) !== -1) return null;
					else return row;
				});
			} else {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000108'),
					buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: () => this.delete(deleteRows) }] //삭제
				});
			}
		},

		//위젯 정보 저장(추가/수정)
		save(saveRows) {
			try {
				this.schema.validateSync(saveRows);

				this.$sf_toggleLoading(true);
				this.save_(saveRows)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//위젯 삭제(미사용 처리)
		async delete(deleteRows) {
			this.$sf_toggleLoading(true);
			await this.delete_(deleteRows)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
